__turbopack_context__.v({
  "copy": "BoutiqueDetailAbout-module-scss-module__h0qPQW__copy",
  "image": "BoutiqueDetailAbout-module-scss-module__h0qPQW__image",
  "inner": "BoutiqueDetailAbout-module-scss-module__h0qPQW__inner",
  "media": "BoutiqueDetailAbout-module-scss-module__h0qPQW__media",
  "paragraph": "BoutiqueDetailAbout-module-scss-module__h0qPQW__paragraph",
  "section": "BoutiqueDetailAbout-module-scss-module__h0qPQW__section",
  "visuallyHidden": "BoutiqueDetailAbout-module-scss-module__h0qPQW__visuallyHidden",
});
